import TwoLineTitle from "../components/TheTwoLineTitle.vue";
import { Validation } from "../utils/validation";
import { deletePointExchangeMagnification } from "../api";
import { Authorize } from "../utils/authorize";
export default {
    components: { TwoLineTitle },
    data() {
        return {
            serviceInfo: [],
            form: {
                pointExchangeMagnificationId: "",
                sourceService: "",
                targetService: "",
                exchangeMagnification: "",
                effectivePeriodDate: null,
            },
        };
    },
    created() {
        const query = this.$route.query;
        if (query.pointExchangeMagnificationId)
            this.form.pointExchangeMagnificationId =
                query.pointExchangeMagnificationId;
        if (query.sourceService)
            this.form.sourceService = query.sourceService;
        if (query.targetService)
            this.form.targetService = query.targetService;
        if (query.exchangeMagnification)
            this.form.exchangeMagnification = query.exchangeMagnification;
        if (query.effectivePeriodDate)
            this.form.effectivePeriodDate = Number(query.effectivePeriodDate);
    },
    methods: {
        validate(form) {
            const errors = [];
            const maxMagnification = 99999.99999;
            const minMagnification = 0;
            // 必須チェック
            errors.push(...Validation.requiredInput({
                key: "交換元サービス",
                value: form.sourceService,
            }));
            errors.push(...Validation.requiredInput({
                key: "交換先サービス",
                value: form.targetService,
            }));
            errors.push(...Validation.requiredInput({
                key: "交換倍率",
                value: form.exchangeMagnification,
            }));
            errors.push(...Validation.requiredInput({
                key: "有効日数",
                value: form.effectivePeriodDate,
            }));
            // 交換倍率の半角数字チェック
            errors.push(...Validation.isHalfWidthNumber({
                key: "交換倍率",
                value: form.exchangeMagnification,
            }));
            // 交換倍率の小数点以下5桁チェック
            const checkDecimalPlaces = (value) => {
                if (!value)
                    return false;
                const parts = value.split(".");
                return parts.length === 2 && parts[1].length > 5;
            };
            if (form.exchangeMagnification &&
                checkDecimalPlaces(form.exchangeMagnification)) {
                errors.push("交換倍率は小数点以下5桁までで入力してください。");
            }
            // 交換倍率の範囲チェック
            const magnificationValue = Number(form.exchangeMagnification);
            if (isNaN(magnificationValue) ||
                magnificationValue < minMagnification ||
                magnificationValue > maxMagnification) {
                errors.push(`交換倍率は${minMagnification}以上${maxMagnification}以下で入力してください。`);
            }
            // 有効日数の整数チェック
            errors.push(...Validation.isInteger({
                key: "有効日数",
                value: form.effectivePeriodDate,
            }));
            // 有効日数の桁数
            errors.push(...Validation.digitsMax({ key: "有効日数", value: form.effectivePeriodDate }, 4));
            // 交換元・先サービスの重複チェック
            if (form.sourceService &&
                form.targetService &&
                form.sourceService === form.targetService) {
                errors.push("交換元サービスと交換先サービスは異なるものを選択してください。");
            }
            return errors;
        },
        async handleSetting() {
            const errors = this.validate(this.form);
            if (errors.length > 0) {
                this.$store.commit("setMessages", errors);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            try {
                // API呼び出し用のオブジェクト作成
                // API登録処理呼び出し
                const response = await deletePointExchangeMagnification(this.form.pointExchangeMagnificationId);
                if (response.result?.code === 9) {
                    this.$store.commit("setMessages", response.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    // 登録成功後に交換検索画面へ遷移
                    this.$router.push("/searchPointExchangeMagnification");
                }
            }
            catch (error) {
                console.error(error);
                alert("更新に失敗しました。");
            }
        },
        onCancel() {
            this.$router.back();
        },
        onSubmit() {
            this.handleSetting();
        },
    },
    async mounted() {
        await Authorize.isExpired(this);
    },
};
